import { render } from "./RzPage.vue?vue&type=template&id=429f080e&scoped=true"
import script from "./RzPage.vue?vue&type=script&lang=js"
export * from "./RzPage.vue?vue&type=script&lang=js"

import "./RzPage.vue?vue&type=style&index=0&id=429f080e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429f080e"]])

export default __exports__